import React, {useEffect, useRef, useState} from "react";
import {inactiveTab, StyledTab, TabHeaderContainer, TabsHolder, Slider} from "./styles";
import {isNaN} from "formik";

export const Tab = ({label, active, onClick}) => {
    return (
        <StyledTab
            role={"tab"}
            active={active}
            onClick={onClick}
            inactiveStyle={inactiveTab}
        >
            {label}
        </StyledTab>
    )
}

export const Tabs = ({selectedTab, onChange, children}) => {
    const containerRef = useRef(null)
    const [containerWidth, setContainerWidth] = useState(0)
    useEffect(() => {
        let width = containerRef.current.getBoundingClientRect().width
        if (!isNaN(width)) {
            setContainerWidth(width)
        }
    }, [containerRef])


    const sliderWidth = containerWidth / children.length

    const tabs = children.map(child => {
        const handleClick = (e) => {
            onChange(e, child.key)
        }

        return React.cloneElement(child, {
            key: child.props.value,
            active: child.props.value === selectedTab,
            onClick: handleClick
        })
    })
    return (
        <TabHeaderContainer ref={containerRef}>
            <TabsHolder>
                {tabs}
            </TabsHolder>
            <Slider width={isNaN(sliderWidth) ? 0 : sliderWidth} index={selectedTab}/>
        </TabHeaderContainer>
    )
}

